export default function shuffle (xs) {
  xs = [ ...xs ]
  const ys = []

  let idx = xs.length
  while (idx !== 0) {
    const rnd = Math.floor(Math.random() * idx)
    idx -= 1
    const tmp = xs[idx]
    ys[idx] = xs[rnd]
    xs[rnd] = tmp
  }

  return ys
}
